import React from 'react';
import { Helmet } from 'react-helmet-async';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import './HomeScreen.css';

export default function HomeScreen() {
  return (
    <div className="home-screen">
      <Helmet>
        <title>Ikaze - Digital Dining Experience</title>
      </Helmet>

      <div className="hero-section text-center text-white d-flex align-items-center justify-content-center flex-column">
        <Container>
          <img src="/logo.png" alt="Ikaze Logo" className="mb-4 logo-hero" style={{ maxWidth: '150px', borderRadius: '50%' }} />
          <h1 className="display-4 fw-bold mb-3">Welcome to Ikaze</h1>
          <p className="lead mb-5">Experience seamless digital dining. Scan, Order, Enjoy.</p>

          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <Link to="/scan">
              <Button variant="primary" size="lg" className="px-5 py-3 rounded-pill shadow">
                <i className="fas fa-qrcode me-2"></i> Scan QR Code
              </Button>
            </Link>
            <Link to="/menu">
              <Button variant="outline-light" size="lg" className="px-5 py-3 rounded-pill">
                <i className="fas fa-book-open me-2"></i> View Menu
              </Button>
            </Link>
          </div>
        </Container>
      </div>

      <Container className="py-5 text-center">
        <h2 className="mb-5 text-primary">How It Works</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="p-4 h-100 feature-card">
              <div className="icon-wrapper mb-3 text-primary">
                <i className="fas fa-qrcode fa-3x"></i>
              </div>
              <h4>1. Scan to Order</h4>
              <p className="text-muted">Scan the QR code on your table to access our digital menu instantly.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 h-100 feature-card">
              <div className="icon-wrapper mb-3 text-primary">
                <i className="fas fa-utensils fa-3x"></i>
              </div>
              <h4>2. Choose Your Favorites</h4>
              <p className="text-muted">Browse our delicious selection of food and drinks and customize your order.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 h-100 feature-card">
              <div className="icon-wrapper mb-3 text-primary">
                <i className="fas fa-concierge-bell fa-3x"></i>
              </div>
              <h4>3. We Serve You</h4>
              <p className="text-muted">Sit back and relax. Our kitchen prepares your meal and we bring it to your table.</p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
